import React from 'react'

const SVG = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 108 104"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M42.4819 76.632C63.1825 76.632 79.9637 60.5966 79.9637 40.816C79.9637 21.0354 63.1825 5 42.4819 5C21.7812 5 5 21.0354 5 40.816C5 60.5966 21.7812 76.632 42.4819 76.632Z" stroke={fill} stroke-width="10"/>
    <path d="M70.0527 67.16L103 98.6432" stroke={fill} stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default SVG;


